<template>
  <div
    name="rb-loader"
    v-if="open"
  >
    <img src="@/assets/loading.gif">
    <span>Carregando...</span>
  </div>
</template>

<script setup lang="ts">
import { loaderStore } from '@/store/app';
import { computed } from 'vue';
const open = computed(loaderStore().isOpen);
</script>

<style scoped lang="scss">
div[name="rb-loader"] {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background-color: rgba(255, 255, 255, 0.9);


  &>img {
    width: 32px;
    height: 32px;
  }

  &>span {
    color: #0DA6A6;
    font-size: 0.8rem;
  }
}
</style>
